var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagicSelectionPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Magic Selection Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 19.77H21.75V4.21999H9.6125V6.09981H19.875V17.895H4.13033V11.6075H2.25V19.77ZM10.7969 10.7919L12 8.14499L13.2031 10.7919L15.85 11.995L13.2031 13.1981L12 15.845L10.7969 13.1981L8.15 11.995L10.7969 10.7919ZM3.4375 10.245H5.3125V7.3075H8.25V5.4325H5.3125V2.495H3.4375V5.4325H0.5V7.3075H3.4375V10.245Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicSelectionPlus);
export default __webpack_public_path__ + "static/media/icon-magic-selection-plus.dbdd0919e4c7fc7c082e67c0c1c01046.svg";
export { ForwardRef as ReactComponent };